import apiClient from './config';

const token = localStorage.getItem('token');
const headers = token ? { 'Authorization': token } : {};

const productApi = {
  // Get products with search, pagination and category filter
  getProducts: async (params = {}) => {
    try {
      const defaultParams = {
        search: '',
        page_size: 100,
        page_number: 1,
        category_id: '',
        ...params
      };

      const response = await apiClient.get('/product', {
        params: defaultParams,
        ...(token && { headers }) // ✅ only include headers if token exists
      });
      return response.data
    } catch (error) {
      throw error;
    }
  },

  // Get product by ID
  getProductById: async (productId) => {
    try {
      const response = await apiClient.get(`/product/${productId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get redeem products (products that can be redeemed with points)
  getRedeemProducts: async (params = {}) => {
    try {
      const defaultParams = {
        search: '',
        page_size: 100,
        page_number: 1,
        redeem_flg: 1,
        ...params
      };

      const response = await apiClient.get('/product', { params: defaultParams });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default productApi; 